export default __webpack_public_path__ + "static/media/added-voice-instruction.38dc4868.svg";